<div class="columns has-background-white">
  <div class="column custom-box p-3 removeY">
    <mat-tab-group mat-align-tabs="center">
      <mat-tab label="{{ 'breadcrumb.history-result.mode.sections' | translate }}">
        <div class="container">
          <div *ngIf="!isSectionsReady">
            <div class="alert alert-warning text-center" role="alert">
              {{ 'breadcrumb.history-result.mode.error' | translate }}
            </div>
          </div>

          <div *ngIf="isSectionsReady">
            <div class="container">
              <div *ngIf="!isClassicReady">
                <div class="alert alert-warning text-center" role="alert">
                  {{ 'breadcrumb.history-result.mode.error' | translate }}
                </div>
              </div>

              <mat-expansion-panel *ngFor="let item of finalItineraryHistory">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <strong>{{ item.name | translate | uppercase }}</strong>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <code *ngIf="isClassicReady" [innerHTML]="item.screenResult"></code>
              </mat-expansion-panel>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="{{ 'breadcrumb.history-result.mode.classic' | translate }}">
        <div class="container">
          <div *ngIf="!isClassicReady">
            <div class="alert alert-warning text-center" role="alert">
              {{ 'breadcrumb.history-result.mode.error' | translate }}
            </div>
          </div>
          <div *ngIf="isClassicReady">
            <span [innerText]="classicHistory"></span>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
